import Contact from '../models/Contact';


const PropagationModels = {
    Contact: Contact,
};

export default PropagationModels;
